module.exports = __webpack_public_path__ + "img/itx-file-type-mpeg.0fce0d51.svg";